module.exports = __webpack_public_path__ + "static/2017_WSC_Group_2017_Rental_Property_Tax_Checklist-93b60ec5804e4247684f8c63321daef0.pdf";